import axios from 'axios';

// Temporary induction access is deliberately separate from the normal app login:
// its own token key (sessionStorage, so it ends with the tab) and its own axios instance.
const TOKEN_KEY = 'cs_induction_token';

export const getInductionToken   = () => sessionStorage.getItem(TOKEN_KEY);
export const setInductionToken   = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearInductionToken = () => sessionStorage.removeItem(TOKEN_KEY);

const inductionApi = axios.create({
  baseURL: '/api/induction-access',
  headers: { 'Content-Type': 'application/json' },
});

inductionApi.interceptors.request.use((config) => {
  const token = getInductionToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default inductionApi;
